import { render, staticRenderFns } from "./crudProductsCompound.vue?vue&type=template&id=0db884cc"
import script from "./crudProductsCompound.vue?vue&type=script&lang=js"
export * from "./crudProductsCompound.vue?vue&type=script&lang=js"
import style0 from "./crudProductsCompound.vue?vue&type=style&index=0&id=0db884cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports